import { copy } from "shared/assets";
import { IActionDropdownItem } from "shared/components";
import { IStatus } from "shared/types";

const {
  members: { pendingIvitationsTable: tableCopy },
} = copy;

export const getPendingInvitationsActions = ({
  handleSend,
  handleEdit,
  handleEditPermissions,
  handleDelete,
}: {
  handleSend: () => void;
  handleEdit: () => void;
  handleEditPermissions: () => void;
  handleDelete: () => void;
}): IActionDropdownItem[] => {
  const actions: IActionDropdownItem[] = [
    {
      label: tableCopy.actions.send,
      handleClick: handleSend,
      dataTestId: "send_invitation_action",
    },
    {
      label: tableCopy.actions.edit,
      handleClick: handleEdit,
      dataTestId: "edit_invitation_action",
    },
    {
      label: tableCopy.actions.permissions,
      handleClick: handleEditPermissions,
      dataTestId: "edit_permission_action",
    },
    {
      label: tableCopy.actions.delete,
      handleClick: handleDelete,
      status: IStatus.error,
      dataTestId: "delete_invitation_action",
    },
  ];

  return actions;
};
